<template>
  <div class="active-enrollment-widget">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <span class="badge badge-success mr-2 p-1 font-size-12">
          <i class="fe fe-user-check"></i> Active
        </span>
        <h6 class="mb-0 font-weight-bold text-dark">Active Students</h6>
      </div>
      <div class="text-right">
        <span class="font-size-24 font-weight-bold text-success">{{ activeCount || 0 }}</span>
        <span class="text-muted font-size-12 ml-1">/ {{ students || 0 }}</span>
      </div>
    </div>

    <div class="d-flex align-items-center mt-3">
      <div class="progress-ring-container flex-shrink-0">
        <a-progress
          type="dashboard"
          :width="75"
          :stroke-width="8"
          :percent="enrolledPercent"
          :success-percent="activePercent"
        />
      </div>
      <div class="ml-3 flex-grow-1">
        <div class="d-flex align-items-center justify-content-between mb-2 font-size-13">
          <span class="text-gray-6"><i class="fe fe-check-circle text-success mr-1"></i>Enrolled:</span>
          <strong class="text-dark font-size-14">{{ enrolled || 0 }}</strong>
        </div>
        <div class="d-flex align-items-center justify-content-between font-size-13">
          <span class="text-gray-6"><i class="fe fe-users text-primary mr-1"></i>Total Students:</span>
          <strong class="text-dark font-size-14">{{ students || 0 }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeoActiveEnrollmentCard',
  props: {
    students: {
      type: [Number, String],
      default: 0,
    },
    enrolled: {
      type: [Number, String],
      default: 0,
    },
    notEnrolled: {
      type: [Number, String],
      default: 0,
    },
    activeCount: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    enrolledPercent() {
      const total = Number(this.students) || 0
      const count = Number(this.enrolled) || 0
      if (total > 0 && count > 0) {
        return Math.round((count / total) * 100)
      }
      return 0
    },
    activePercent() {
      const total = Number(this.students) || 0
      const count = Number(this.activeCount) || 0
      if (total > 0 && count > 0) {
        return Math.round((count / total) * 100)
      }
      return 0
    },
  },
}
</script>

<style scoped>
.active-enrollment-widget {
  width: 100%;
}
.progress-ring-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
